import React from 'react';
import { promptAuthAndWishlistFromURL } from './wishlistUtils';
import './style.scss';
import { checkIfCustomer } from '../../../utils/helpers';
import { WishlistGA4ProductData, addItemToWishlist } from './wishlistState';

const WishlistButtonCart = ({
  onClickCallback,
  item,
}: {
  onClickCallback: () => void;
  item: WishlistGA4ProductData;
}) => {
  return (
    <button
      className="wishlist-button-cart body-text-link-small p-0"
      type="button"
      onClick={() => {
        if (checkIfCustomer()) {
          addItemToWishlist(item, {});
          onClickCallback();
        } else {
          promptAuthAndWishlistFromURL('Cart', item);
        }
      }}
    >
      {`Move to Wishlist`}
    </button>
  );
};

export default WishlistButtonCart;
